import React from 'react';
import { motion } from 'framer-motion';
import { ArrowUpRight } from 'lucide-react';

const PROJECTS = [
  {
    title: 'Helios Trading Platform',
    category: 'Web App / Fintech',
    metric: '+312% trading volume',
    image: 'https://images.pexels.com/photos/27141307/pexels-photo-27141307.jpeg',
  },
  {
    title: 'Northwind Logistics OS',
    category: 'Automation / SaaS',
    metric: '47 hrs / week saved',
    image: 'https://images.unsplash.com/photo-1720962158937-7ea890052166?crop=entropy&cs=srgb&fm=jpg&q=85',
  },
  {
    title: 'Lume AI Concierge',
    category: 'AI / Hospitality',
    metric: '92% guest satisfaction',
    image: 'https://images.unsplash.com/photo-1666698809123-44e998e93f23?crop=entropy&cs=srgb&fm=jpg&q=85',
  },
  {
    title: 'Atlas Marketing Engine',
    category: 'Marketing / D2C',
    metric: '4.1x return on ad spend',
    image: 'https://images.unsplash.com/photo-1638864616275-9f0b291a2eb6?crop=entropy&cs=srgb&fm=jpg&q=85',
  },
];

export const Portfolio = () => {
  return (
    <section id="portfolio" data-testid="portfolio-section" className="relative py-24 lg:py-40 px-6 lg:px-12 border-t border-white/10">
      <div className="max-w-[1400px] mx-auto">
        <div className="grid lg:grid-cols-12 gap-8 mb-16 lg:mb-24">
          <div className="lg:col-span-7">
            <div className="flex items-center gap-3 mb-6">
              <span className="w-1.5 h-1.5 bg-brand-primary" />
              <span className="font-manrope text-xs uppercase tracking-[0.3em] text-white/60">
                04 — Selected Work
              </span>
            </div>
            <h2 className="font-outfit font-black tracking-tighter text-white text-5xl lg:text-7xl leading-[0.9]">
              Results,<br />in production.
            </h2>
          </div>
          <div className="lg:col-span-4 lg:col-start-9 flex items-end">
            <p className="font-manrope text-base text-white/60 leading-relaxed">
              A small slice of what we&apos;ve shipped recently. Every engagement
              has a number attached &mdash; because intent without measurement is decoration.
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-4 lg:gap-6">
          {PROJECTS.map((p, i) => (
            <motion.a
              key={p.title}
              href="#contact"
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-50px' }}
              transition={{ duration: 0.7, delay: (i % 2) * 0.1, ease: [0.22, 1, 0.36, 1] }}
              data-testid={`portfolio-card-${i}`}
              className={`group relative block overflow-hidden bg-brand-surface border border-white/5 hover:border-white/20 transition-all duration-500 ${
                i % 3 === 0 ? 'md:translate-y-0' : 'md:translate-y-8'
              }`}
            >
              <div className="relative aspect-[4/3] overflow-hidden">
                <img
                  src={p.image}
                  alt={p.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110 opacity-80 group-hover:opacity-100"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />
                <div className="absolute top-4 right-4 w-10 h-10 bg-brand-primary text-black flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <ArrowUpRight size={18} />
                </div>
              </div>
              <div className="p-6 lg:p-8 flex items-end justify-between gap-4">
                <div>
                  <span className="font-manrope text-xs uppercase tracking-[0.2em] text-white/40">
                    {p.category}
                  </span>
                  <h3 className="mt-2 font-outfit font-bold text-2xl lg:text-3xl text-white tracking-tight">
                    {p.title}
                  </h3>
                </div>
                <span className="shrink-0 font-manrope text-xs text-brand-primary uppercase tracking-wider whitespace-nowrap">
                  {p.metric}
                </span>
              </div>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
};
